import { Injectable } from '@angular/core';
import { AlertService } from '@full-fledged/alerts';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(private alertService: AlertService) { }

  public showError(err: any): void {
    console.log(err);

    if (err.status === 404) {
      return this.alertService.danger('Something went wrong');
    }
    
    let errorMessage = err.error.globalErrors[0].message ? err.error.globalErrors[0].message : '';
    if (err.status === 401 && errorMessage === 'jwt expired') {
      return;
    }

    if (err.error) {
      if (err.error.globalErrors && err.error.globalErrors.length) {
        err.error.globalErrors.forEach((element: any) => {
          this.alertService.danger(element.message);
        });
      }

      if (err.error.fieldErrors && err.error.fieldErrors.length) {
        err.error.fieldErrors.forEach((element: any) => {
          this.alertService.danger(element.message);
        });
      }

    } else {
      this.alertService.danger(err);
    }

  }
}
